<template>
  <div class="container-fluid" style="padding:0;">
    <tab></tab>
    <div class="row">
      <div class="activity-top" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <img :src="projectInfo.picStr" alt="#" class="inner-item-img"/>
        <div class="activity-top-right columnCenter">
          <div class="mechanism-neck-title" style="text-align: left;margin-bottom:0.2125rem;">{{lanType==1?projectInfo.title:projectInfo.titleEn}}</div>
          <div class="mechanism-neck-time" style="text-align: left;margin-bottom:0.1125rem;">{{lanType==1?projectInfo.updated_at:projectInfo.updated_at}}</div>
          <div class="neck-center-top start" v-if="pageInfo.project_tag_name || pageInfo.project_tag_nameEn">
            <div class="center-top-tips">{{lanType==1?'标签':'label'}}：</div>
            <div class="center-top-list">{{lanType==1?pageInfo.project_tag_name:pageInfo.project_tag_nameEn}}</div>
            <!-- <div class="center-top-list bg1">RE买家联盟</div>
            <div class="center-top-list bg2">气候创行者</div> -->
          </div>
        </div>
        <!-- <div class="activity-top-font">
          <div class="top-font-font" v-if="type==1">{{lanType==1?'新闻动态':'News information'}}</div>
          <div class="top-font-font" v-else>{{lanType==1?'出版物详情':'Publication details'}}</div>
        </div> -->
      </div>

      <div class="phone-activity-top hidden-md hidden-lg" v-if="isShowWeb">
        <img :src="projectInfo.picStr" alt="#" class="phone-inner-img"/>
        <!-- <div class="activity-top-font">
          <div class="phone-font-font" v-if="type==1">{{lanType==1?'新闻动态':'News information'}}</div>
          <div class="phone-font-font" v-else>{{lanType==1?'出版物详情':'Publication details'}}</div>
        </div> -->
      </div>
    </div>

    <div class="row">
      <div class="mechanism-neck" :class="{'hidden-xs hidden-sm':isShowWeb}">
        
        <div class="mechanism-neck-center">
          
          <div class="neck-center-center">
            <div class="center-center-font" v-html="lanType==1?projectInfo.content:projectInfo.contentEn"></div>
            <!-- <img src="@/images/addCbh.jpg" alt="#" class="center-center-img"/>
            <div class="center-center-tips">WWF成立时的意见书  ©WWF</div>
            <div class="center-center-font">近年来，气候变化引发的极端天气、水资源短缺、供应链危机等都是影响企业运营发展的潜在风险。根据联合国政府间气候变化专门委员会的报告，气温每上升1°C，粮食产量就下降约5%。气候变化引发的极端天气也是引发今年8月亚马孙雨林大火的诱因之一。根据联合国发布的《2019年世界经济形势与展望》，1998年至2017年之间，与气候相关的灾害造成的损失高达22,450亿美元。</div>
            <div class="center-center-font">企业既是温室气体的主要排放者，同时又是气候友好型解决方案的创新者和提供者，可以在应对气候变化、实现中国低碳经济转型方面起到关键作用。</div>
            <div class="center-center-font">围绕“低碳先行 企业双赢”的主题，交流会设立了企业案例分享、主题讨论以及问答三个环节，加深企业对科学碳目标倡议的理解、明确自身的时代使命。</div> -->
          </div>
        </div>
      </div>

      <div class="phone-mechanism hidden-md hidden-lg" v-if="isShowWeb">
        <div class="phone-mechanism-neck">{{lanType==1?projectInfo.title:projectInfo.titleEn}}</div>
        <div class="phone-mechanism-time">{{lanType==1?projectInfo.updated_at:projectInfo.updated_at}}</div>
        <div class="phone-mechanism-center">
          <div class="phone-center-top start" v-if="pageInfo.project_tag_name || pageInfo.project_tag_nameEn">
            <div class="phone-top-tips">{{lanType==1?'标签':'label'}}：</div>
            <div class="phone-center-list">{{lanType==1?projectInfo.project_tag_name:projectInfo.project_tag_nameEn}}</div>
            <!-- <div class="phone-center-list bg1">RE买家联盟</div>
            <div class="phone-center-list bg2">气候创行者</div> -->
          </div>
          <div class="phone-neck-center">
            <div class="phone-center-font" v-html="lanType==1?projectInfo.content:projectInfo.contentEn"></div>
            <!-- <img src="@/images/addCbh.jpg" alt="#" class="phone-center-img"/>
            <div class="phone-center-tips">WWF成立时的意见书  ©WWF</div>
            <div class="phone-center-font">近年来，气候变化引发的极端天气、水资源短缺、供应链危机等都是影响企业运营发展的潜在风险。根据联合国政府间气候变化专门委员会的报告，气温每上升1°C，粮食产量就下降约5%。气候变化引发的极端天气也是引发今年8月亚马孙雨林大火的诱因之一。根据联合国发布的《2019年世界经济形势与展望》，1998年至2017年之间，与气候相关的灾害造成的损失高达22,450亿美元。</div>
            <div class="phone-center-font">企业既是温室气体的主要排放者，同时又是气候友好型解决方案的创新者和提供者，可以在应对气候变化、实现中国低碳经济转型方面起到关键作用。</div>
            <div class="phone-center-font">围绕“低碳先行 企业双赢”的主题，交流会设立了企业案例分享、主题讨论以及问答三个环节，加深企业对科学碳目标倡议的理解、明确自身的时代使命。</div> -->
          </div>
        </div>
      </div>
    </div>

    <footerBar ref="footerView"></footerBar>
  </div>
</template>

<script>
import tab from '@/components/tab';
import footerBar from '@/components/footerBar';
import axios from 'axios';
import { chunkArr,format } from '@/utils/util';
import config from '@/utils/config';
export default {
  name: 'wprk',
  components: {
    tab:tab,
    footerBar:footerBar
  },
  data () {
    return {
      carouselList:[],
      lanType:1,
      pageInfo:{},
      projectInfo:{},
      type:1,
      id:'',
      isShowWeb:config.urlList.isShowWeb
    }
  },
  methods:{
    fatherMethod(type){
      const vm=this
      vm.lanType=type
      setTimeout(()=>{
        vm.$refs.footerView.choiceType(type);
      },400)
    },
    setTitle(da){
      const vm=this
      if(da.project_tag_nameEn){
        return da
      }
      switch (da.project_tag_name) {
        case '科学碳目标':
          da.project_tag_nameEn = "Science Based Target initiative (SBTi)";
          break;
        case '科学碳目标简介':
          da.project_tag_nameEn = "Introduction";
          break;
        case '设置科学碳目标':
          da.project_tag_nameEn = "Setting SBTi";
          break;
        case '案例':
          da.project_tag_nameEn = "Best practice";
          break;
        case '活动':
          da.project_tag_nameEn = "Events";
          break;
        case '绿色电力需求行动':
          da.project_tag_nameEn = "China Corporate Renewable Energy Program";
          break;
        case '绿色电力需求倡议':
          da.project_tag_nameEn = "Renewable Energy Buyers' Principles";
          break;
        case '绿色电力采购评估工具':
          da.project_tag_nameEn = "Buyers' Evaluation Tool";
          break;
        case '绿色电力应用培训课程':
          da.project_tag_nameEn = "Buyers' Curriculum";
          break;
        case '绿色电力应用试点项目':
          da.project_tag_nameEn = "Corporate RE Pilot Project";
          break;
        case '活动':
          da.project_tag_nameEn = "Events";
          break;
        case '气候创行者':
          da.project_tag_nameEn = "Climate Solver";
          break;
        case '气候创行者简介':
          da.project_tag_nameEn = "Introduction";
          break;
        case '加入CBH':
          da.project_tag_nameEn = "JoinUs";
          break;
        case '绿色电力需求倡议':
          da.project_tag_nameEn = "Renewable Energy Buyers' Principles";
          break;
        case '绿色电力采购评估工具':
          da.project_tag_nameEn = "Buyers' Evaluation Tool";
          break;
        case '绿色电力应用培训课程':
          da.project_tag_nameEn = "Buyers' Curriculum";
          break;
        case '绿色电力应用试点项目':
          da.project_tag_nameEn = "Corporate RE Pilot Project";
          break;
        case '企业气候行动共同体邀请函':
          da.project_tag_nameEn = "CBH invitation letter";
          break;
        case '企业共同体组织机制':
          da.project_tag_nameEn = "CBH Organization mechanism";
          break;
        case '绿色电力需求倡议':
          da.project_tag_nameEn = "Renewable Energy Buyers' Principles";
          break;
        case '联系方式':
          da.project_tag_nameEn = "Contact information";
          break;
        default: 
          da.project_tag_nameEn = da.project_tag_name;
      }
      return da
    },
    queryProject(){
      const vm=this
      let obj = {
        id:vm.$route.query.id,
        token:localStorage.getItem("Cbhtoken")
      }
      axios.post(
      `${config.urlList.queryUrl}/api/cbh/project`,obj
      ).then(res => {
        if(res.data.code==1){
          res.data.data.picStr=`${config.urlList.imgUrl}${res.data.data.pic}`;
          res.data.data.updated_at = format(new Date(res.data.data.updated_at),'YYYY-MM-DD')

          res.data.data.content = res.data.data.content ? res.data.data.content.replace(/(width|height)="\d*"\s*/g, '') : ''

          vm.projectInfo=res.data.data
          document.title = vm.projectInfo.title+' ' + localStorage.getItem("CbhTitle")
          
          if(res.data.data.parent_id==10||res.data.data.parent_id==12){
            vm.parent_id=res.data.data.parent_id
            vm.queryProjectList2(vm.parent_id)
          }
          //vm.queryvideos();
        }else{
          vm.$toast({
            text: '请登录后再试！',
            type: 'danger',
            duration: 1600
          })
          //vm.$router.push({ path:'/'  })
        }
      })
    },
    queryProjectList2(index){
      const vm=this
      let arr=vm.projectList
      axios.get(`${config.urlList.queryUrl}/api/cbh/project_list/${index}`).then(res => {
        if(res.data.code==1){
          res.data.data.forEach(da=>{
            da.picStr=`${config.urlList.imgUrl}${da.pic}`
          })
          vm.legList = res.data.data
        }
      })
    },
  },
  created () {
    const vm = this;
  },
  mounted(){
    const vm=this
    vm.type = vm.$route.query.type||1
    vm.queryProject();
  }
}
</script>

<style scoped>
/**  pc banner图  **/
.activity-top{
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}
.inner-item-img{
  width: 60%;
  height: auto;
}
.activity-top-right{
  padding: 0.35rem 20% 0.1rem;
  height: 100%;
  align-items: flex-start;
}
.activity-top-font{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.top-font-font{
  font-size: 0.375rem;
  color: #fff;
}
/**  web Banner图  **/
.phone-activity-top{
  width: 100%;
  height: 8rem;
  position: relative;
}
.phone-inner-img{
  width: 100%;
  height: 100%;
}
.phone-font-font{
  font-size: 0.8rem;
  color: #fff;
}

/**  pc  **/
.mechanism-neck{
  padding: 0 20% 0.35rem;
  height: auto;
}
.mechanism-neck-title{
  font-size: 0.225rem;
  color: #000;
  text-align: center;
  line-height: 1.6;
  font-family: 'wwf';
}
.mechanism-neck-time,.center-top-tips{
  font-size: 0.1125rem;
  color: #999999;
  line-height: 1.6;
  text-align: center;
}
.mechanism-neck-center{
  height: auto;
}
.center-top-list{
  padding: 0 0.125rem;
  height: 0.2rem;
  font-size: 0.1rem;
  color: #666666;
  /* background: #32a5cf; */
  text-align: center;
  line-height: 0.2rem;
  margin-right: 0.16rem;
  text-decoration: underline
}

.center-center-font{
  font-size: 0.1125rem;
  line-height: 1.6;
  margin-bottom: 0.2rem;
  text-align: left;
}
.center-center-img{
  width: 5.625rem;
  height: auto;
  margin-bottom: 0.15rem;
}
.center-center-tips{
  font-size: 0.1rem;
  color: #999;
  text-align: center;
  margin-bottom: 0.225rem;
}

/**  web  **/

.phone-mechanism{
  padding: 0.35rem 0.5rem;
  height: auto;
}
.phone-mechanism-neck{
  font-size: 0.48rem;
  color: #000;
  text-align: center;
  line-height: 1.6;
  font-family: 'wwf';
}
.phone-mechanism-time,.phone-top-tips{
  font-size: 0.32rem;
  color: #999999;
  line-height: 1.6;
  text-align: center;
}
.phone-mechanism-center{
  margin-top: 0.4rem;
  height: auto;
}
.phone-center-list{
  width: 2rem;
  height: 0.8rem;
  font-size: 0.32rem;
  color: #fff;
  background: #32a5cf;
  text-align: center;
  line-height: 0.8rem;
  margin-right: 0.3rem;
}
.phone-neck-center{
  margin-top: 0.4rem;
}
.phone-center-font{
  font-size: 0.32rem;
  line-height: 1.6;
  margin-bottom: 0.4rem;
  text-align: left;
}
.phone-center-img{
  width: 100%;
  height: auto;
  margin-bottom: 0.3rem;
}
.phone-center-tips{
  font-size: 0.32rem;
  color: #999;
  text-align: center;
  margin-bottom: 0.4rem;
}
.bg1{
  background: #436aba;
}
.bg2{
  background: #ed9534;
}
</style>
